<div class="acc-completed-engagements-view-part">
	<common-engagement-grid [pageService]="pageService" [data]="engagements()"></common-engagement-grid>
</div>